// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavLink_wrapper__1NOqt","active":"NavLink_active__hi3mU","icon":"NavLink_icon__p9Kmp","label":"NavLink_label__31Y55"};